import formatUpdatedLocale from './format-updated-locale';

/**
 * Update DPA Locale in dpaTransactionOptions when locale is changed in SRCi
 * @param {object} dcf
 * @param {string} locale
 */

const updateDpaLocale = (dcf, updatedLocale) => {
  const locale = formatUpdatedLocale(updatedLocale);
  if (dcf.dpaTransactionOptions && dcf.dpaTransactionOptions.dpaLocale) {
    dcf.dpaTransactionOptions.dpaLocale = locale;
  }
};

export default updateDpaLocale;
